const FooterData = {
    CompanyWidget: [
        {
            id: 1,
            title: "Get In Touch",
            description: "Don’t miss any updates of our team.!",
        }
    ],
    AboutWidget: [
        {
          id: 1,
          title: "Download",
          menuItems: [
              {
                id: 1,
                url: '#',
                text: 'Company',
              },
              {
                id: 2,
                url: '#',
                text: 'Android App',
              },
              {
                id: 3,
                url: '#',
                text: 'ios App',
              },
              {
                id: 4,
                url: '#',
                text: 'Desktop',
              },
              {
                id: 5,
                url: '#',
                text: 'Projects',
              },
              {
                  id: 6,
                  url: '#',
                  text: 'My tasks',
              },
          ],
      },
      {
            id: 2,
            title: "Help",
            menuItems: [
                {
                  id: 1,
                  url: '#',
                  text: 'FAQ',
                },
                {
                  id: 2,
                  url: '#',
                  text: 'Term & conditions',
                },
                {
                  id: 3,
                  url: '#',
                  text: 'Reporting',
                },
                {
                  id: 4,
                  url: '#',
                  text: 'Documentation',
                },
                {
                  id: 5,
                  url: '#',
                  text: 'Support Policy',
                },
                {
                    id: 6,
                    url: '#',
                    text: 'Privacy',
                  },
            ],
        },
    ],
    termsCondition: [
      {
          id: 1,
          title: "Team Solutions",
          menuItems: [
            {
              id: 1,
              url: '#',
              text: 'Support',
            },
            {
              id: 2,
              url: '#',
              text: 'Sales',
            },
            {
              id: 3,
              url: '#',
              text: 'Report Abuse',
            },
            {
              id: 4,
              url: '#',
              text: 'System Status',
            }
        ],
      }
    ],
    SocialLinks: [
        {
            id: 1,
            title: "Team Solutions",
            menuItems: [
                {
                  id: 1,
                  url: 'https://www.facebook.com/GreenHubLKbyBackSlash',
                  icon: 'ti-facebook',
                },
                {
                  id: 2,
                  url: 'https://www.linkedin.com/company/team-backslash',
                  icon: 'ti-linkedin',
                },
                {
                  id: 3,
                  url: 'https://www.youtube.com/channel/UCez-R8JSjQl7LP-mJVsPk-w',
                  icon: 'ti-youtube',
                },
                {
                  id: 4,
                  url: 'https://vimeo.com/user155852485',
                  icon: 'ti-vimeo-alt',
                }
            ]
        }
    ],
    socialIcon:[
      {
        id: 1,
        url: 'https://www.facebook.com/',
        icon: 'ti-facebook',
      },
      {
        id: 2,
        url: '#',
        icon: 'ti-linkedin',
      },
      {
        id: 3,
        url: '#',
        icon: 'ti-vimeo-alt',
      },
      {
        id: 4,
        url: '#',
        icon: 'ti-pinterest',
      }
    ],
    copywrite:"© Team </BackSlash>.. 2021 All rights reserved.",
    TestimonialText: [
      {
        id: 1,
        image: "new/member_01.jpg",
        description: "Photo එකක් භාවිතා කරලා වගාවෙ තියෙන ලෙඩේ මොකද්ද කියලා ඉක්මනින් හොයා ගන්න පුළුවන් වෙන එක දැන් කාලෙ ගොවියොන්ට ගොඩක් වටිනවා.!",
        authorName: "Manjula Sirisena",
        authorPost: "Farmer, Galle",
      },
      {
        id: 2,
        image: "new/member_02.jpg",
        description: "GreenHub LK has proven to be an application smart enough to provide satisfactory results not only for the farmers but also for the relevant authorities as well. It will not be far away to reach a time where GreenHub LK has dominated the farming world.",
        authorName: "K.P.N.A. Pathirana",
        authorPost: "Divisional Environmental Officer",
      },
      {
        id: 3,
        image: "new/member_03.jpg",
        description: "අපේ ඵලදාවට වැඩිම වටිනාකමක් තියෙන වෙළඳපොල සොයාගන්න පුළුවන්වීම ගොවියන්ට ලොකු වාසියක්. ඒවගෙම අපිට අපේ ඵලදාව GreenHubLK හරහා අතරමැදියෙක් නොමැතිව කෙලින්ම විකුනා ගන්න අවස්ථාව සලසන නිසා අමතර වියදම් අඩුවෙනවා.",
        authorName: "Sunil Witharana",
        authorPost: "Farmer, Anuradapura",
      },
      {
        id: 4,
        image: "new/member_04.jpg",
        description: "This is an app with a very good concept that is designed to cover many aspects of the field of agriculture. Very Useful and very informative. Good effort by the Team Backslash!",
        authorName: "Ashini Ishara",
        authorPost: "Undergraduate , University of Colombo",
      }
    ],
    aboutLinks: [
      {
        id: 1,
        url: '#',
        item: 'Developer',
      },
      {
        id: 2,
        url: '#',
        item: 'Blog',
      },
      {
        id: 3,
        url: '#',
        item: 'Investor',
      },
      {
        id: 4,
        url: '#',
        item: 'Sitemap',
      },
      {
        id: 5,
        url: '#',
        item: 'Jobs',
      }
    ],
    helpLinks: [
      {
        id: 1,
        url: '#',
        item: 'Help and Contact',
      },
      {
        id: 2,
        url: '#',
        item: 'Fees',
      },
      {
        id: 3,
        url: '#',
        item: 'Security',
      },
      {
        id: 4,
        url: '#',
        item: 'App',
      },
      {
        id: 5,
        url: '#',
        item: 'Shop',
      }
    ],
    PrivacyLinks: [
      {
        id: 1,
        url: '#',
        item: 'Privacy Policy',
      },
      {
        id: 2,
        url: '#',
        item: 'Legal Agreement',
      },
      {
        id: 3,
        url: '#',
        item: 'Feedback',
      }
    ],
    about: [
      {
        id: 1,
        url: '#',
        text: 'Company',
      },
      {
        id: 2,
        url: '#',
        text: 'Leadership',
      },
      {
        id: 3,
        url: '#',
        text: 'Diversity',
      },
      {
        id: 4,
        url: '#',
        text: 'Jobs',
      },
      {
        id: 5,
        url: '#',
        text: 'Press',
      },
      {
        id: 6,
        url: '#',
        text: 'Wavelength',
      },
    ],
    Solution: [
      {
        id: 1,
        url: '#',
        text: 'Project Management',
      },
      {
        id: 2,
        url: '#',
        text: 'Agile',
      },
      {
        id: 3,
        url: '#',
        text: 'Task Management',
      },
      {
        id: 4,
        url: '#',
        text: 'Reporting',
      },
      {
        id: 5,
        url: '#',
        text: 'Work Tracking',
      },
      {
        id: 6,
        url: '#',
        text: 'See All Uses',
      },
    ],
    teamSolution: [
      {
        id: 1,
        url: '#',
        text: 'Engineering',
      },
      {
        id: 2,
        url: '#',
        text: 'Designers',
      },
      {
        id: 3,
        url: '#',
        text: 'Sales',
      },
      {
        id: 4,
        url: '#',
        text: 'Developers',
      },
      {
        id: 5,
        url: '#',
        text: 'Marketing',
      },
      {
        id: 6,
        url: '#',
        text: 'See All team',
      },
    ],
};
export default FooterData;
